import APIAxios from '../APIAxios.ts';
import ICastVote from '../view_modals/ICastVote.ts'
import ISubmitVote from '../view_modals/ISubmitVote.ts'
import IUpdatePercentage from '../view_modals/IUpdatePercentage.ts';

const getTeamForVoting = async (sessionId) => {
    try {
        const response = await APIAxios.get(`/Voting/GetTeamForVoting/${sessionId}`);
        const data = response.data;
        return data;
    } catch (err) {
        throw err;
    }
};



const castVote = async (vm: ICastVote) => {
    try {
        const response = await APIAxios.post(`/Voting/CastVote`, vm);
        const data = response.data;
        return data;
    } catch (err) {
        throw err;
    }
};

const getVotes = async (sessionId, teamId) => {
    try {
        const response = await APIAxios.post(`/Voting/GetVotes/${sessionId}/${teamId}`);
        const data = response.data;
        return data;
    } catch (err) {
        throw err;
    }
};

const isVotingStarted = async (sessionId) => {
    try {
        const response = await APIAxios.get(`/Voting/IsVotingStarted/${sessionId}`);
        const data = response.data;
        return data;
    } catch (err) {
        throw err;
    }
};

const submitVotes = async (vm: ISubmitVote) => {
    try {
        const response = await APIAxios.post(`/Voting/SubmitVotes`, vm);
        const data = response.data;
        return data;
    } catch (err) {
        //throw err;
    }
};

const moveToNextTeam = async (sessionId) => {
    try {
        const response = await APIAxios.get(`/Voting/MoveToNextTeam?sessionId=${sessionId}`);
        const data = response.data;
        return data;
    } catch (err) {
        throw err;
    }
};

const startVoting = async (sessionId) => {
    try {
        const response = await APIAxios.get(`/Voting/StartVoting/${sessionId}`);
        const data = response.data;
        return data;
    } catch (err) {
        throw err;
    }
};

const checkIfTeamVotedForTeam = async (sessionId, votedForTeamId, votedByTeamId) => {
    try {
        const response = await APIAxios.get(`/Voting/CheckIfTeamVotedForTeam/${sessionId}?votedForTeamId=${votedForTeamId}&votedByTeamId=${votedByTeamId}`);
        const data = response.data;
        return data;
    } catch (err) {
        throw err;
    }
};

const isSelfVotingSessionCompleted = async (sessionId) => {
    try {
        const response = await APIAxios.get(`/Voting/IsSelfVotingSessionCompleted/${sessionId}`);
        const data = response.data;
        return data;
    } catch (err) {
        throw err;
    } 
}

const updatePercentages = async (vm: IUpdatePercentage) => {
    try {
        const response = await APIAxios.post(`/voting/UpdatePercentage`, vm);
        const data = response.data;
        return data;
    } catch (err) {
        throw err;
    }
}


const votingService = {
    getVotes,
    getTeamForVoting,
    castVote,
    isVotingStarted,
    submitVotes,
    moveToNextTeam,
    startVoting,
    checkIfTeamVotedForTeam,
    isSelfVotingSessionCompleted,
    updatePercentages
  };
  
  export default votingService;
  